<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6" style="border-top: solid #f1c40f 4px;">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">folder</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Dokumente</h2>
      </div>
    </div>

    <!-- Search Box -->
    <div class="mb-6">
      <div class="w-full max-w-md">
        <div class="relative">
          <input
            type="text"
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
            placeholder="Suche Dokumente..." 
            [(ngModel)]="searchValue"
            (keyup)="onSearch()"
          />
          <button
            *ngIf="searchValue"
            type="button"
            class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            (click)="clearSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoadingResults" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Dokumente...</span>
    </div>

    <!-- Documents Table -->
    <div class="mt-8 flow-root" *ngIf="!isLoadingResults && dataSource.data.length > 0">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Dateiname</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Typ / Größe</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Hochgeladen von</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Datum</th>
                <th scope="col" class="py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let dokument of dataSource.data; let i = index" 
                class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                  <div class="flex items-start">
                    <mat-icon class="mr-2 text-gray-400 mt-0.5 flex-shrink-0">{{ getFileTypeIcon(dokument.mime_type) }}</mat-icon>
                    <div class="min-w-0 flex-1">
                      <div class="break-words">{{ dokument.original_filename }}</div>
                      <div *ngIf="dokument.description" class="text-xs italic text-gray-500 dark:text-gray-400 break-words">{{ dokument.description }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div>
                    <div class="font-medium break-words">{{ getDisplayCategory(dokument.mime_type) }}</div>
                    <div class="text-xs">{{ formatFileSize(dokument.file_size) }}</div>
                  </div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.user_full_name || dokument.user_name || 'Unbekannt' }}</div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.uploadDate | date:'dd.MM.yyyy' }}</div>
                </td>
                <td class="py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <button
                    (click)="downloadDokument(dokument)"
                    mat-button
                    color="primary"
                    class="slim-button flex-shrink-0">
                    Download
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!isLoadingResults && totalItems > 0"
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [pageIndex]="currentPage - 1"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of documents">
    </mat-paginator>

    <!-- Empty State -->
    <div *ngIf="!isLoadingResults && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 w-24 h-24 mb-4">folder</mat-icon>
      <p class="text-gray-500 text-lg">Keine Dokumente gefunden</p>
    </div>
  </div>
</div>

